module.exports = __webpack_public_path__ + "img/sensor_0_1.bd67ac1b.png";